import { defineStore } from 'pinia'
import { onMounted, ref } from 'vue'
import { localDriver } from '@/utils/localDriver'

export const useOrderStore = defineStore('order', () => {
  const bookingSteps = ref([
    { title: 'Flight Preference', path: 'flight' },
    { title: 'Order Filling', path: 'booking' },
    { title: 'Travel Protection', path: 'booking/insurance' },
    { title: 'Checkout/Payment', path: 'payment' }
  ])

  const currentBookingStep = ref(0)

  const token = ref(null)

  const prices = ref(null)
  async function loadOrder(odkey: string) {
    const orderData = odkey == '' ? null : await localDriver.getItem(odkey)
    console.log('loadOrder', {...orderData})
    return orderData
  }

  async function loadRooms(rmkey: string) {
    const roomData = rmkey == '' ? null : await localDriver.getItem(rmkey)
    return roomData
  }

  async function setOrderPrices(opkey: string, prices: string) {
    await localDriver.setItem(opkey, prices)
  }

  async function loadOrderPrices(opkey: string) {
    const pricesData = opkey == '' ? null : await localDriver.getItem(opkey)
    return pricesData
  }

  function toBookingStep(step: number) {
    currentBookingStep.value = step
  }

  async function setProductId(id: number) {
    if (token.value == null||token.value.trim()==="") {
      const val = id.toString() + new Date().getTime().toString()
      token.value = val
      const currentUrl = new URL(window.location.href)
      currentUrl.searchParams.set('tk', val)
      history.pushState(null, '', currentUrl.toString());
    }
  }

  async function setProduct(id: number, keyword: string) {
    await setProductId(id)
    if(null!=keyword){
      await localDriver.setItem('p_token_key_' + token.value, keyword)
    }
  }

  async function setToken(tk: string) {    
    if (token.value == null) {
      token.value = tk
    }
  }

  const tk = new URLSearchParams(window.location.search).get('tk')
  token.value = tk

  return {
    prices,
    bookingSteps,
    currentBookingStep,
    token,
    setToken,
    setProduct,
    toBookingStep,
    loadOrder,
    loadOrderPrices,
    setOrderPrices,
    loadRooms
  }
})
